module.exports = __webpack_public_path__ + "img/smartknife1.89868fc7.png";